import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import styles from './kdsPrepStations.module.scss';
import kdsStyles from '../common/KDSCSS/kdsScreens.module.scss'
import Modal from '@components/common/Modal';
import cn from 'classnames';
import ExpoTime from '../KdsExpoStationScreens/expoTime';
import SearchComponent from '@components/common/search/SearchComponent';
import { createFilter } from '@utility/helperFunction';
import { LABEL } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import Tooltip from '../KdsExpoStationScreens/ToolTip';
import moment from 'moment';
import expand from '@assets/images/KDSICONS/expand.svg';
import prioritizeIcon from '@assets/images/KDSICONS/prioritizeIcon.svg';
import NewIcon from '@assets/images/KDSICONS/newOrder.png';
import Navbar from '../common/Navbar/index.jsx';
import HamburgerSideBarMenu from '../common/HamburgerSideBarMenu/index';
import Footer from '../common/Footer/index';
import TicketExpandModal from './ticketExpand';
import { connect } from 'react-redux';
import StationCardLoader from '../common/StationCardLoader/index';
import downArrow from '@assets/images/KDSICONS/downArrow.svg';
import upArrow from '@assets/images/KDSICONS/upArrow.svg';
import checkBoxIcon from '@assets/images/KDSICONS/checkBox.svg';


const PrepFooter = ({
  filterData,
  footerSelection,
  i,
  setCurrentPage
}) => {
  return (
    <div
      id={i.name}
      key={i.name}
      className={cn('col-2 row fs-12 fw-600 mx-1 rounded overflowX overflowYHidden align-items-center color-black h-90', styles.footerCard)}
      style={filterData?.[i.name] ? { background: "#C1D0FF" } : { background: "white" }}
      role="presentation"
      onClick={() => { footerSelection(i); setCurrentPage(0); }}
    >
      <div className="col-12 px-1 text-capitalize text-center">{i.name.length > 8 ? i.name.substring(0, 8) + '..' : i.name}{'(' + (i.notSchedule + i.Schedule) + ')'}</div>
    </div>
  );
};

const renderModifier = (modifiersObj) => (
  (modifiersObj || []).map((modifier) => (
    <div key={modifier.modifierId} className={modifier.price ? 'col-12 text-left p-0' : 'd-none'}>
      {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName}`}
      {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
      {modifier?.modifiers && modifier?.modifiers?.length > 0 && (
        <div className="pl-2">
          {renderModifier(modifier.modifiers)}
        </div>
      )}
    </div>
  ))
);

const StationCard = ({
  check,
  checkindex,
  bumpApiCall,
  prepStartAll,
  searchOverlay,
  convertUTCDateToLocalDate,
  themeProperties,
  bumpApiSelected,
  getTileHeight,
  getPrepCompletedTime,
  duplicateDeviceIds,
  handleTicketExpandView,
  getWarningError,
  getWarningErrorColor,
  currentPage,
  getTime,
  loading,
  lastActiveTime,
  receipePdfApiCall,
  pdfUrl,
  setPdfUrl,
  checkPrepsListHashTable,
  filterData,
  setRecipeModalData,
  currentState,
  getPickupTime,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const deviceInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('deviceInfo'), false));
  const columnCount = deviceInfo.columnCount;
  const kdsSettings = deviceInfo.deviceGroup.kdsSettings;
  const orderTypeName = check[0]?.checkPrep?.checkHeader?.orderTypeName ? check[0]?.checkPrep?.checkHeader?.orderTypeName : '';
  const revenueCenterName = check[0]?.checkPrep?.checkHeader?.revenueCenterName ? check[0]?.checkPrep?.checkHeader?.revenueCenterName : '';
  const innerWidth = window.innerWidth;
  const [headerColor, setHeaderColor] = useState('');
  const [loaderId, setLoaderId] = useState('');
  const [selectedObjects, setSelectedObjects] = useState({});

  useEffect(() => {
    if (loading === false) {
      setLoaderId('')
    }
  }, [loading])

  let width = 33;
  if (columnCount) {
    width = 100 / columnCount
  }
  const substringLength = width < 18 ? Math.floor(width * 3 / orderTypeName.length) : width <= 20 ? Math.floor(width * 5 / orderTypeName.length) : width < 33 ? Math.floor(width * 5 / orderTypeName.length) : 10;
  const substringLengthTwo = width < 18 ? Math.floor(width * 3 / orderTypeName.length) : width < 33 ? Math.floor(width * 7 / orderTypeName.length) : 10;


  const subStringName = (sentence) => {
    return (sentence.length !== sentence.substring(0, substringLength).length ? sentence.substring(0, substringLength) + sentence.length !== 0 ? `${sentence.substring(0, substringLength)}..` : '' : width > 18 ? sentence : sentence.substring(0, 3))

  }

  const subStringNameTwo = (sentence) => {
    return (sentence.length !== sentence.substring(0, substringLengthTwo).length ? sentence.substring(0, substringLengthTwo) + sentence.length !== 0 ? '..' : '' : width > 18 ? sentence : sentence.substring(0, 3))

  }


  const [scrollPosition, setScrollPosition] = useState(0);
  const [scrollDownCount, setScrollDownCount] = useState();
  const [scrollUpCount, setScrollUpCount] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, [containerRef.current, containerRef.current?.scrollHeight, checkPrepsListHashTable, filterData, currentState]);

  useEffect(() => {
    const container = containerRef.current;
    const { scrollHeight, clientHeight } = container;
    setScrollPosition(0);
    setScrollUpCount(0);
    const upScrollCount = (scrollHeight - clientHeight) / 100;
    setScrollDownCount(upScrollCount === 0 ? Math.ceil(upScrollCount) : Math.floor(upScrollCount) + 1);
  }, [containerRef.current, containerRef.current?.scrollHeight, currentPage, checkPrepsListHashTable, filterData, currentState]);

  const handleScroll = (event) => {
    const container = event.target;
  };

  const handleScrollUpButtonClick = () => {
    const container = containerRef.current;
    const newPosition = scrollPosition - 100;
    if (scrollPosition > 0) {
      container.scrollTo({ top: newPosition, behavior: "smooth" });
      setScrollPosition(newPosition);
      setScrollUpCount(scrollUpCount - 1);
      setScrollDownCount(scrollDownCount + 1);
    }
  };

  const handleScrollDownButtonClick = () => {
    const container = containerRef.current;
    if (scrollPosition + container.clientHeight < container.scrollHeight - 1) {
      const newPosition = scrollPosition + 100;
      container.scrollTo({ top: newPosition, behavior: "smooth" });
      setScrollPosition(newPosition);
      setScrollDownCount(scrollDownCount - 1);
      setScrollUpCount(scrollUpCount + 1)
    }
  };
  const handleScrolling = (e) => {
    const container = e.target;
    const { scrollTop, scrollHeight, clientHeight } = container;
    const upScrollCount = (scrollHeight - scrollTop - clientHeight) / 100;
    setScrollDownCount(upScrollCount === 0 ? Math.ceil(upScrollCount) : Math.floor(upScrollCount) + 1);
    const totalCount = Math.ceil((scrollHeight - clientHeight) / 100);
    const updateUpCount = totalCount - scrollDownCount;
    setScrollUpCount(prevCount => (upScrollCount === 0 || upScrollCount === 0.01) ? totalCount : updateUpCount)
    const newPosition = scrollTop;
    setScrollPosition((prevPosition) => prevPosition + (newPosition - prevPosition))

  }

  const handleCheckboxChange = (event, item, checkId) => {
    const selectedObject = { id: checkId }; // create a new object with an id property

    if (event.target.checked) {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: [...(prevState[selectedObject.id] || []), item] // add the selected object to the array with the corresponding id
        };
      });
    } else {
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [selectedObject.id]: prevState[selectedObject.id].filter(obj => obj.entityId !== item.entityId) // remove the object from the array with the corresponding id
        };
      });
    }

    // log the selected objects array for debugging purposes
  };


  function
    getColor(prepStatus, i) {
    let curTime = new Date().getTime();
    let plannedPrepStartDate = convertUTCDateToLocalDate(new Date(i.plannedPrepStartDate)).getTime();
    if (deviceInfo.deviceGroup?.kdsWarningTime1 != 0 && deviceInfo.deviceGroup?.kdsWarningTime1 != null) {
      if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
        return themeProperties ? 'od-live-orders' : styles.bgGrey
      } else if (prepStatus == 2 && curTime < plannedPrepStartDate) {
        return themeProperties ? 'od-held-orders' : 'color-secondary'
      } else if (prepStatus == 5) {
        return styles.bgBlue
      }
      else if (prepStatus == 8) {
        return styles.bgSuccess
      }
    } else if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
      return themeProperties ? 'od-live-orders' : styles.bgGrey
    } else if (prepStatus == 2 && curTime < plannedPrepStartDate) {
      return themeProperties ? 'od-held-orders' : 'bg-secondary'
    } else if (prepStatus == 5) {
      return styles.bgBlue
    } else if (prepStatus == 8) {
      return styles.bgSuccess
    }
    return styles.bgLightGray
  }


  const individualItemSquare = (prepStatus, i) => {
    let curTime = new Date().getTime();
    let plannedPrepStartDate = convertUTCDateToLocalDate(new Date(i.plannedPrepStartDate)).getTime();
    if (prepStatus == 2 && (i.plannedPrepStartDate === null || curTime < plannedPrepStartDate)) {
      return '#767676'
    } else if (prepStatus == 2 && curTime >= plannedPrepStartDate) {
      return '#767676'
    } else if (prepStatus == 5) {
      return '#0060FF'
    } else if (prepStatus == 8) {
      return '#18BD63'
    } else {
      return '#d1d1d1'
    }
  }

  const onClose = () => {
    setIsOpen(false)
  }
  const bumpSelected = (check, checkPrepId) => {

    let items = [];
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      items.push({ ...element })
    }
    bumpApiSelected(check, 'buildSelectedBump', items)
    for (let i = 0; i < selectedObjects[checkPrepId].length; i++) {
      const element = selectedObjects[checkPrepId][i];
      setSelectedObjects(prevState => {
        return {
          ...prevState, // copy the previous state
          [checkPrepId]: prevState[checkPrepId].filter(obj => obj.entityId !== element.entityId) // remove the object from the array with the corresponding id
        };
      });
    }
  }

  const checkBoxCheck = (data, id) => {
    if (data != undefined) {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (element.entityId === id) {
          return true
        }
      }
    }
    return false
  }

  const getBuildCompletedTime = (value) => {
    // UTC timings
    var utcTime1 = moment.utc(value.prepStartDate).local();
    var utcTime2 = moment.utc(value.prepCompleteDate).local();

    // Calculate the difference in milliseconds
    var diff = utcTime2.diff(utcTime1);
    // Convert the difference to minutes and seconds
    var duration = moment.duration(diff);
    var minutes = Math.floor(duration.asMinutes());
    var seconds = Math.floor(duration.asSeconds()) % 60;
    // Format the minutes and seconds as 00:00
    var formattedTime = moment.utc().startOf('day').add(minutes, 'minutes').add(seconds, 'seconds').format('mm:ss');

    // // Display the difference time
    return formattedTime
  }



  const renderItemModifiers = (item, itemId, modPadding) => {
    const modifiers = item?.modifiers?.map((modifierItem, modifierIndex) => {
      return (
        <div key={modifierItem.name + modifierIndex} className={`row mx-0 w-100 ${modifierIndex < item.length - 1 ? 'pb-2' : ''}`} style={{ fontSize: 'max(1.1vw, 1.1vh)', }}>
          <div className={cn(columnCount <= 4 ? "w-10" : "w-13")}>
            {(modifierItem.plannedPrepStartDate) &&
              <input type='checkbox' style={{ width: columnCount <= 4 && '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, modifierItem, itemId)} checked={checkBoxCheck(selectedObjects[itemId], modifierItem?.entityId)} disabled={modifierItem.buildStatus === 8} />
            }
          </div>
          {(modifierItem.plannedPrepStartDate) ?
            <div className={cn("col-6 text-left", kdsStyles.modifiers)} style={{ overflowY: 'scroll', whiteSpace: "nowrap", textDecoration: modifierItem.buildStatus === 8 ? "line-through" : '', textDecorationColor: 'red', color: modifierItem?.allergy ? 'red' : getTime(modifierItem.plannedPrepStartDate) ? 'black' : 'gray', paddingLeft: modPadding + 'px' }}>
              - {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''} &nbsp;{modifierItem.name}
              <div className="text-left pl-2" style={{ color: '#CE842A', fontSize: 'max(1.1vw, 1.1vh)', width: 'max-content' }}>
                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
              </div>
            </div>
            :
            <div className={cn("col-6 text-left", kdsStyles.modifiers)} style={{ overflowY: 'scroll', whiteSpace: "nowrap", paddingLeft: modPadding + 'px' }}>
              - {modifierItem?.quantity > 1 ? modifierItem?.quantity + 'x' : ''} &nbsp;{modifierItem.name}
              <div className="text-left pl-2" style={{ fontSize: 'max(1.1vw, 1.1vh)', color: '#CE842A', width: 'max-content' }}>
                {`${modifierItem.comment ? `- ${modifierItem.comment}` : ''}`}
              </div>
            </div>
          }
          {modifierItem.plannedPrepStartDate ?
            <div className="col-md px-1 text-right d-flex justify-content-end align-items-center">
              {getWarningError(modifierItem) && getWarningErrorColor(modifierItem) && <div className='pr-1'>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={getWarningErrorColor(modifierItem)}>
                  <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                  <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                  <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                </svg>
              </div>}
              <i className={cn(`fa fa-circle fs-12 fa-rotate-180`)} style={{ color: individualItemSquare(modifierItem.prepStatus, item) }} aria-hidden="true" />
              <span className="ml-1">{modifierItem.prepStatus != 8 ? <ExpoTime date={modifierItem.plannedPrepStartDate} /> : getPrepCompletedTime(modifierItem)}</span>
            </div> : <div className='col-3'></div>}
          {modifierItem?.modifiers && modifierItem?.modifiers?.length > 0 && renderItemModifiers(modifierItem, itemId, modPadding + 10)}
        </div>
      )
    });
    return modifiers;
  }

  const getheaderColor = (items, headerColorId) => {
    items?.forEach(item => {
      if (item.warningColorId > headerColorId) {
        headerColorId = item.warningColorId;
      } else {
        return item.warningColorId
      }
      if (headerColorId === 4) return headerColorId;
      if (item?.modifiers?.length > 0) {
        headerColorId = getheaderColor(item?.modifiers, headerColorId);
        if (headerColorId === 4) return headerColorId;
      }
    });
    return headerColorId;
  }

  const rendercheckItems = (items, isModifier) => {
    let hasNewItem = false;
    const itemData = items?.map(item => {
      let modData = [];
      if (item?.modifiers?.length > 0) modData = rendercheckItems(item.modifiers, true);
      let warningColorId = !getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? 0 : item.prepStatus == 0 && item.buildStatus == 0 ? isModifier ? 0 : 1 : getWarningError(item) ? getWarningErrorColor(item) : 1;
      warningColorId = warningColorId === '' || warningColorId === undefined ? 1 : warningColorId === 'yellow' ? 2 : warningColorId === '#F49F40' ? 3 : warningColorId === '#FF6464' ? 4 : warningColorId;

      if (!isModifier) {
        if (!hasNewItem && warningColorId === 1 && item.buildStatus < 5) {
          hasNewItem = true;
        }
      }
      return { ...item, modifiers: modData, warningColorId }
    });
    if (!isModifier) setHasNewItem(hasNewItem);
    return itemData;
  }

  useEffect(() => {
    const items = rendercheckItems(check, false);
    const headerColors = ['gray', '#18BD63', 'yellow', '#F49F40', '#FF6464'];
    const headerColorId = getheaderColor(items, 0);
    setHeaderColor(headerColors[headerColorId]);
  }, [check]);

  const getMinStartTime = (item) => {
    const buildStartDate = item[0]?.prepStartDate ? item[0]?.prepStartDate : item[0]?.plannedPrepStartDate;
    let minDate = buildStartDate;

    item?.forEach((el) => {
      let tempStartDate = el.prepStartDate ? el.prepStartDate : el.plannedPrepStartDate;

      if (el?.modifiers?.length > 0) {
        el?.modifiers?.forEach((modEl) => {
          minDate = getMinModifierDate(modEl, minDate);
        })
      }
      else {
        if (moment(minDate)?.isSameOrAfter(moment(tempStartDate))) {
          minDate = tempStartDate;
        }
      }

    })
    return minDate;
  }

  const getMinModifierDate = (item, minDate) => {
    let newMinDate = minDate;
    if (item?.modifiers?.length > 0) {
      getMinModifierDate(item.modifiers[0], newMinDate);
    }
    else {
      if (item.prepStartDate || item.plannedPrepStartDate) {
        let tempModStartDate = item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate;

        if (moment(newMinDate)?.isSameOrAfter(moment(tempModStartDate))) {
          newMinDate = tempModStartDate;
        }

      }
    }
    return newMinDate
  }

  const handleBumbBtnClr = () => {
    return check && check?.some((el) => { return el.prepStatus >= 5 })
  }

  const getSortedData = (check) => {

    let obj = {};

    check?.forEach((item) => {

      let { seatId } = item;

      if (!kdsSettings?.groupBySeat) {
        seatId = 1234;
      }

      if (!obj[seatId]) {
        obj[seatId] = []
      }

      obj[seatId].push(item);

    })

    for (let key in obj) {
      let allDayItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.prepStartDate ? val.prepStartDate : val.plannedPrepStartDate).local();
        const currentTime = moment();
        return val.prepStatus != 8 && currentTime > momentTime
      });

      allDayItems = allDayItems.sort((a, b) => {
        const timeA = new Date(a.prepStartDate ? a.prepStartDate : a.plannedPrepStartDate).getTime();
        const timeB = new Date(b.prepStartDate ? b.prepStartDate : b.plannedPrepStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let scheduledItems = obj[key].filter(val => {
        const momentTime = moment.utc(val.prepStartDate ? val.prepStartDate : val.plannedPrepStartDate).local();
        const currentTime = moment();
        return val.prepStatus != 8 && currentTime < momentTime
      });

      scheduledItems = scheduledItems.sort((a, b) => {
        const timeA = new Date(a.prepStartDate ? a.prepStartDate : a.plannedPrepStartDate).getTime();
        const timeB = new Date(b.prepStartDate ? b.prepStartDate : b.plannedPrepStartDate).getTime();

        if (timeA === timeB) {
          // If timing is the same, sort based on name property
          return a.name.localeCompare(b.name);
        }

        return timeA - timeB;
      });

      let completedItems = obj[key].filter(val => val.prepStatus == 8)?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      obj[key] = [...allDayItems, ...scheduledItems, ...completedItems];

    }

    return obj;

  };

  return (

    <div id={check[0]?.checkPrep?.checkHeader?.id} data-cards={check[0]?.checkPrep?.checkHeader?.id} key={check[0]?.checkPrep?.checkHeader?.id} className={cn('h-100 w-100', searchOverlay ? styles.opacity : '', styles.p3)}>
      <div className={cn(`h-100  bg-white color-black `, styles?.expoStationCards)} style={{ border: `2px solid ${duplicateDeviceIds[check[0]?.prepDeviceId]}` }} >
        {
          loading && (loaderId === check[0]?.checkPrep?.id) && <StationCardLoader />
        }
        <div className={cn(" w-100 fw-600 text-break text-uppercase d-flex mx-0 align-items-stretch justify-content-center color-black", columnCount > 5 ? 'py-2' : 'p-2')} style={{ background: headerColor, fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)', padding: columnCount > 5 && '0.7px' }} >
          <div className={cn(`col-3 d-flex flex-column align-items-start justify-content-center p-0 text-center rounded`)} >
            {check[0]?.checkPrep?.checkHeader?.name?.length > 4 ? <Tooltip innerWidth={innerWidth} text={check[0]?.checkPrep?.checkHeader?.name}>{check[0]?.checkPrep?.checkHeader?.tab === true ? check[0]?.checkPrep?.checkHeader?.name?.length < 4 ? check[0]?.checkPrep?.checkHeader?.name : <span> {check[0]?.checkPrep?.checkHeader?.name?.substring(0, 4)}..</span> : check[0]?.checkPrep?.checkHeader?.stationNumber?.length < 4 ? check[0]?.checkPrep?.checkHeader?.stationNumber : <span> {check[0]?.checkPrep?.checkHeader?.stationNumber?.substring(0, 4)}..</span>}</Tooltip> : <> {check[0]?.checkPrep?.checkHeader?.tab === true ? check[0]?.checkPrep?.checkHeader?.name?.length < 4 ? check[0]?.checkPrep?.checkHeader?.name : <span> {check[0]?.checkPrep?.checkHeader?.name?.substring(0, 4)}</span> : check[0]?.checkPrep?.checkHeader?.stationNumber?.length < 4 ? check[0]?.checkPrep?.checkHeader?.stationNumber : <span> {check[0]?.checkPrep?.checkHeader?.stationNumber?.substring(0, 4)}..</span>} </>}
            <div>{`#${check[0]?.checkPrep?.checkHeader?.number}`}</div>
          </div>

          {((!kdsSettings.displayOrderType && !kdsSettings.displayRevenueCenter) || (kdsSettings.displayOrderType && kdsSettings.displayRevenueCenter) || (deviceInfo.deviceGroup === null)) ? <> <div className={cn("col-4 p-0 d-flex flex-column align-items-center justify-content-center od-text-secondary")} style={{ fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)' }}>
            {kdsSettings?.displayOrderType && <div style={{ fontWeight: 'bold' }}><span>{subStringName(orderTypeName)}</span></div>}
            {kdsSettings?.displayRevenueCenter && <div style={{ fontWeight: 'bold' }}><span>{subStringName(revenueCenterName)}</span></div>}
          </div>
          </> : (kdsSettings.displayOrderType) ? <div className={cn("col-4 p-0 d-flex flex-column align-items-center justify-content-center px-0 od-text-secondary", 'fs-12')} >{subStringNameTwo(orderTypeName)}</div> : <div className={cn("col-5 d-flex align-items-center justify-content-center px-0 od-text-secondary", 'fs-12')} >{subStringNameTwo(revenueCenterName)}</div>
          }

          <div className="col-4 p-0 d-flex flex-column align-items-end justify-content-center od-text-secondary" >
            <div style={{ fontSize: columnCount >= 5 ? 'max(1.1vw, 1.1vh)' : 'max(1.3vw, 1.3vh)' }}>{check[0]?.checkPrep?.checkHeader?.employeeFirstName && check[0]?.checkPrep?.checkHeader?.employeeLastName && `${(check[0]?.checkPrep?.checkHeader?.employeeFirstName.split(' ')[0].length < 4) ? check[0]?.checkPrep?.checkHeader?.employeeFirstName?.split(' ')[0] + " " + check[0]?.checkPrep?.checkHeader?.employeeLastName.substring(0, 4) + '..' : check[0]?.checkPrep?.checkHeader?.employeeFirstName?.split(' ')[0]?.substring(0, 4) + '..'}`}</div>
            <ExpoTime date={getMinStartTime(check)} status={check[0]?.checkPrep?.prepStatus === 5} />
          </div>
        </div>
        <div className={cn(`fs-12 overflowY`)} ref={containerRef} style={{ maxHeight: getTileHeight(check), minHeight: getTileHeight(check)}} onScroll={(e) => handleScrolling(e)}>
          {Object.values(getSortedData(check))?.map((el) => {
            return (
              <>
                {kdsSettings?.groupBySeat && el[0]?.seatNumber &&
                  <div className='w-100 text-center fw-500' style={{ backgroundColor: '#FFFADD', border: kdsSettings?.groupBySeat && '2px solid #BEB893', fontSize: '10px' }}>
                    <span>
                      Seat {el[0]?.seatNumber}
                    </span>
                    {
                      el[0]?.seatName && (
                        <span className='ml-1'>
                          ({el[0]?.seatName?.length > 15 ? el[0]?.seatName?.substring(0, 15) + '..' : el[0]?.seatName})
                        </span>
                      )
                    }
                  </div>
                }
                <>
                  {
                    el?.map((item, checkIndex) => {
                      return (
                        <div className={cn('row mx-0 w-100 od-container-card-background pl-1 pr-1', styles.p3)} style={{ borderBottom: checkIndex < check.length - 1 ? '1px solid #C9C9C9' : '', paddingTop: '7px' }}>
                          <div className={cn(columnCount <= 4 ? "w-10" : "w-13")}>
                            <input type='checkbox' style={{ width: columnCount <= 4 && '100%' }} className={cn('', styles.checkbox)} onChange={(event) => handleCheckboxChange(event, item, item.checkPrep.id)} checked={checkBoxCheck(selectedObjects[item.checkPrep.id], item.entityId)} disabled={item?.prepStatus === 8} />
                          </div>
                          <div className='col-6 pl-1'>
                            <div style={{ textDecoration: item?.prepStatus === 8 ? "line-through" : '', textDecorationColor: 'black', color: item?.allergy ? 'red' : getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? 'black' : 'gray' }}>
                              {item?.quantity > 1 ? item?.quantity + 'x' : '1x'}&nbsp;{item.menuItemName ? item.menuItemName : item.name}
                            </div>
                            <div className={cn("text-left pl-2", kdsStyles.item)} style={{ color: '#CE842A', width: 'max-content' }}>
                              {`${item.comment ? `- ${item.comment}` : ''}`}
                            </div>
                          </div>
                          <div className="col-md px-1 text-right fs-12 d-flex justify-content-end" style={{ fontSize: 'max(1.1vw, 1.1vh)' }}>
                            {getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? <>
                              {getWarningError(item) && getWarningErrorColor(item) && <div className='pr-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 21 19" fill={getWarningErrorColor(item)}>
                                  <path d="M10.3924 13.3518C9.81129 13.3518 9.32422 13.8389 9.32422 14.4199C9.32422 15.001 9.81129 15.4881 10.3924 15.4881C10.9521 15.4881 11.4605 15.001 11.4349 14.4456C11.4605 13.8346 10.9777 13.3518 10.3924 13.3518Z" />
                                  <path d="M20.2786 17.1372C20.9494 15.9793 20.9536 14.5993 20.2871 13.4457L13.5963 1.85856C12.9341 0.692152 11.7378 0 10.3962 0C9.05461 0 7.8583 0.696424 7.19605 1.85428L0.496704 13.4542C-0.169813 14.6206 -0.165541 16.0092 0.509521 17.1671C1.17604 18.3121 2.36808 19 3.70111 19H17.0656C18.4029 19 19.6035 18.3036 20.2786 17.1372ZM18.8259 16.2998C18.4542 16.9406 17.7962 17.3209 17.0614 17.3209H3.69684C2.97051 17.3209 2.31681 16.9492 1.95364 16.3211C1.5862 15.6845 1.58193 14.924 1.94937 14.2831L8.64872 2.68743C9.01188 2.05082 9.66131 1.67484 10.3962 1.67484C11.1268 1.67484 11.7805 2.05509 12.1437 2.6917L18.8387 14.2874C19.1976 14.9112 19.1934 15.6631 18.8259 16.2998Z" />
                                  <path d="M10.1264 5.8534C9.61793 5.99866 9.30176 6.4601 9.30176 7.0198C9.32739 7.35733 9.34876 7.69914 9.37439 8.03667C9.44702 9.3227 9.51966 10.5831 9.59229 11.8691C9.61793 12.3049 9.95546 12.6211 10.3913 12.6211C10.8271 12.6211 11.1689 12.2836 11.1902 11.8435C11.1902 11.5786 11.1902 11.3351 11.2159 11.0659C11.2629 10.2413 11.3141 9.4167 11.3611 8.5921C11.3868 8.05803 11.4338 7.52396 11.4594 6.98989C11.4594 6.79763 11.4338 6.62673 11.3611 6.45583C11.1432 5.9773 10.6348 5.73377 10.1264 5.8534Z" />
                                </svg>
                              </div>}
                              <i className={cn(`fa fa-circle fs-12 fa-rotate-180 ${getColor(item?.prepStatus, check[0])}`)} style={{ color: individualItemSquare(item?.prepStatus, item) }} aria-hidden="true" />
                            </> :
                              <div className='d-flex align-item-center justify-content-center' style={{ height: '1rem', marginRight: '0.6rem', marginBottom: '0.1rem' }}>
                                <i className="fa fa-clock" style={{ color: 'black', fontSize: '0.9rem', lineHeight: '0' }}></i>
                              </div>}
                            <span className="ml-1">{item?.prepStatus !== 8 ? <ExpoTime date={item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate} /> : getBuildCompletedTime(item)}</span>
                          </div>
                          {item?.modifiers && item?.modifiers?.length > 0 && renderItemModifiers(item, item?.checkPrep?.id, 15)}
                        </div>
                      )
                    })
                  }
                </>
              </>
            )
          })}
        </div>
        <div className='row mx-0 w-100 text-center align-content-end position-absolute' style={{
          bottom: '0%',
          cursor: 'pointer',
          background: '#D9D9D9'
        }}>
          {
            check[0]?.checkPrep?.doNotMake && (
              <div className='w-100 d-flex align-items-center justify-content-center' style={{ backgroundColor: '#FF5959', border: '2px solid #9E4444', fontSize: '10px' }}>
                <div className='w-auto text-white px-2'>DO NOT MAKE</div>
              </div>
            )
          }
          {
            check[0]?.checkPrep?.hasAllergy && (
              <div className='w-100 d-flex align-items-center' style={{ backgroundColor: '#F2F2F2', border: '2px solid #CCC', fontSize: '10px' }}>
                <div className='w-auto text-white px-2' style={{ backgroundColor: 'red' }}>Allergy</div>
                <div className='w-80 text-left pl-2'>{check[0].checkPrep?.allergyText &&
                  check[0].checkPrep?.allergyText?.length > 25 ?
                  check[0].checkPrep?.allergyText?.substring(0, 25) + '..' : check[0].checkPrep?.allergyText
                }
                </div>
              </div>
            )
          }
          {
            check[0]?.checkPrep?.offPremise ? (
              <div className='w-100' style={{ backgroundColor: '#E7EEF3', border: '2px solid #98AAB8', fontSize: '10px' }}>
                <div className='d-flex justify-content-between'>
                  <div className='pl-1'>{check[0]?.checkPrep?.checkInNote || ''}</div>
                  <div className='pr-1'>{check[0]?.checkPrep?.pickupTime && getPickupTime(check[0]?.checkPrep?.pickupTime) || ''}</div>
                </div>
                <div className='d-flex justify-content-between'>
                  <div className='pl-1'>
                    {check[0]?.checkPrep?.marketplace ? check[0]?.checkPrep?.marketplaceVendorName : check[0]?.checkPrep?.delivery ? 'Delivery' : 'Pickup'}
                  </div>
                  <div className='pr-1' style={{ color: '#EA6262' }}>{check[0]?.checkPrep?.pickupTime && <ExpoTime date={check[0]?.checkPrep?.pickupTime} />}</div>
                </div>
              </div>
            ) :
              (
                check[0]?.checkPrep?.courseName && (
                  <div className='w-100 d-flex align-items-center justify-content-center' style={{ backgroundColor: '#FFFADD', border: check[0]?.checkPrep?.courseName && '2px solid #BEB893', fontSize: '10px' }}>
                    {
                      check[0]?.checkPrep?.courseName?.length > 25 ?
                        check[0]?.checkPrep?.courseName?.substring(0, 25) + '..' : check[0].checkPrep?.courseName
                    }
                  </div>)
              )
          }
          <div className='col-5 p-0 d-flex color-white'>
            <div className='d-flex flex-column align-items-center w-50' style={{ background: scrollDownCount === 0 ? "#C6C6C6" : '#6A4DAE', padding: '5px' }} onClick={scrollDownCount > 0 ? handleScrollDownButtonClick : undefined}>
              <span>{scrollDownCount}</span>
              <img className={styles.downScrollBtn} src={downArrow} alt="scroll down" width="12px" />
            </div>
            <div className='d-flex flex-column align-items-center w-50' onClick={scrollUpCount > 0 ? handleScrollUpButtonClick : undefined} style={{ background: scrollUpCount === 0 ? "#C6C6C6" : '#6A4DAE', padding: '5px' }}>
              <span>{scrollUpCount}</span>
              <img className={styles.upScrollBtn} src={upArrow} alt="scroll up" width="12px" />
            </div>
            <div className='d-flex flex-column align-items-center w-20 justify-content-center pl-2'>
              {check[0]?.checkPrep?.rePrioritized && (
                <img className='d-flex justify-content-center' src={prioritizeIcon} width="20px" alt="prioritise" />
              )}
              {
                check[0]?.checkPrep?.receivedDate > lastActiveTime && <img className='d-flex justify-content-center' src={NewIcon} width="20px" alt="new-icon" />
              }
            </div>
          </div>
          <div className='col-2 p-0 d-flex justify-content-center' role="button" onClick={() => handleTicketExpandView(check, headerColor)}>
            <img src={expand} alt="expand items" width="20px" />
          </div>
          <div className='col-5 d-flex align-items-center justify-content-center p-0' style={{ backgroundColor: handleBumbBtnClr() ? '#0060FF' : '#71B2FF', color: 'white', zIndex: 1 }} 
          onClick={() => {
            if (
              selectedObjects?.hasOwnProperty(check[0]?.checkPrep?.id + '') &&
              selectedObjects[check[0]?.checkPrep?.id].length > 0
            ) {
              bumpSelected(check, check[0]?.checkPrep?.id + '');
              setLoaderId(check[0]?.checkPrep?.id);
            } else {
              bumpApiCall(check, 'prepTile');
              setLoaderId(check[0]?.checkPrep?.id);
            }
          }} >
            {selectedObjects?.hasOwnProperty(check[0]?.checkPrep?.id + '') && selectedObjects[check[0]?.checkPrep?.id].length > 0 &&
              <img src={checkBoxIcon} alt="bump selected" width="20px" />}
            <span className='pl-1'>{LABEL().KDS_BUMP}</span>
          </div>
        </div>
        <Modal
          isOpen={isOpen}
          isModalCenter={true} customClass2={styles.maxWidth}
        >
          <div style={{ backgroundColor: 'gray' }}>
            <div className="px-2 py-2 text-right">
              <i
                role="presentation"
                onClick={() => onClose()}
                className="fa fa-times fs-30"
                aria-hidden="true"
              />
            </div>
            <div className='text-center mb-5'>
              <button className='w-50 od-btn-primary btn20 ' style={{
                backgroundColor: 'transparent',
                color: 'white',
                border: 'solid',
                paddingBottom: '22px'
              }} onClick={() => { prepStartAll(check[0], 'build'); setIsOpen(false) }} >Bump Items</button>

            </div>
          </div>
        </Modal>
      </div>
    </div>

  );
};
const KdsPrepStation = ({
  groupObj,
  bumpApiCall,
  toggle,
  prepStartAll,
  convertUTCDateToLocalDate,
  columnCount,
  rowCount,
  themeProperties,
  bumpApiSelected,
  getPrepCompletedTime,
  duplicateDeviceIds,
  handleLogout,
  duplicateData,
  activeScreenType,
  History,
  setToggle,
  setHistoryData,
  showMenu,
  setShowMenu,
  counter,
  handleShowRecallModal,
  setRecallData,
  loading,
  lastActiveTime,
  receipePdfApiCall,
  pdfUrl,
  setPdfUrl,
  checkPrepsListHashTable,
  setRecipeModalData,
  filterData,
  setFilterData,
  footerSelection,
  states,
  currentState,
  toggleState,
  getPickupTime,
}) => {
  const [KeyboardOpen, setKeyboardOpen] = useState(true);
  const deviceInfo = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('deviceInfo'), false));
  const [searchString, setSearchString] = useState('');
  const array = Object.values(groupObj || {}).flat();
  const groupedOrderType = {};
  const nodes = [];
  const headerKeys = ['stationName', 'stationNumber', 'name'];
  const headerArray = headerKeys.map((i) => {
    return {
      key: i
    }
  });
  const [searchResults, setSearchResults] = useState(() => {
    return groupedOrderType;
  });
  const [activeNode, setActiveNode] = useState(() => {
    return nodes;
  });
  const [searchOverlay, setSearchOverlay] = useState(false);
  const [viewSingle, setViewSingle] = useState(() => { return { isOpen: false, data: {} }; });
  const [currentPage, setCurrentPage] = useState(0);
  const [pageBuildArr, setPageNewBuildArr] = useState({})
  const [showTicketExpandModal, setShowTicketExpandModal] = useState(false);
  const [ticketExpandData, setTicketExpandData] = useState(null);
  const [headerCount, setHeaderCount] = useState({
    newOrder: 0,
    processCount: 0,
    inProgress: 0,
    yellowCount: 0,
    orangeCount: 0,
    redCount: 0
  })
  let isItemInAllDay = false;
  const kdsSortType = deviceInfo?.deviceGroup?.kdsSortType;

  useEffect(() => {
    setCurrentPage(0)
  }, [duplicateDeviceIds])

  const getWarningError = (item) => {
    if (item.prepStatus == 5) {
      return true
    }
    const momentTime = moment.utc(item.plannedPrepStartDate).local();
    const currentTime = moment();
    const diffTime = currentTime.diff(momentTime, 'seconds');
    const momentDate = momentTime.format('YYYY-MM-DD');
    let time;
    if (currentTime > momentTime) {
      time = moment(momentDate).startOf('day')
        .seconds(diffTime)
        .format('mm:ss');
    } else {
      time = moment(momentDate).startOf('day')
        .seconds(momentTime.diff(currentTime, 'seconds'))
        .format('mm:ss')
      time = " - " + time;
    }
    var utcTime1 = moment();
    var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
    let t = Math.floor((utcTime1 - utcTime2) / 1000);
    return time.includes('-') ? false : Number(t) > deviceInfo.deviceGroup.kdsWarningTime1 ? true : false
  }
  const getWarningErrorColor = (item) => {
    if (item.prepStatus == 5) {
      if (!item.prepCompleteDate) {
        var utcTime1 = moment();
        var utcTime2 = moment.utc(item.plannedPrepCompleteDate).local();
        let time = Math.floor((utcTime1 - utcTime2) / 1000);
        if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
          return 'yellow'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#F49F40'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#FF6464'
        }
      } else {
        var utcTime1 = moment.utc(item.prepCompleteDate).local();
        var utcTime2 = moment.utc(item.plannedPrepCompleteDate).local();
        // Calculate the difference in milliseconds
        var time = Math.floor((utcTime1 - utcTime2) / 1000);
        if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
          return 'yellow'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#F49F40'
        } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
          return '#FF6464'
        }
      }
    }
    if (!item.prepStartDate) {
      var utcTime1 = moment();
      var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
      let time = Math.floor((utcTime1 - utcTime2) / 1000);
      if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
        return 'yellow'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#F49F40'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#FF6464'
      }
    } else {
      var utcTime1 = moment.utc(item.prepStartDate).local();
      var utcTime2 = moment.utc(item.plannedPrepStartDate).local();
      // Calculate the difference in milliseconds
      var time = Math.floor((utcTime1 - utcTime2) / 1000);
      if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime1 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime2) {
        return 'yellow'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime2 && Number(time) < deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#F49F40'
      } else if (Number(time) > deviceInfo.deviceGroup.kdsWarningTime3) {
        return '#FF6464'
      }
    }
  }

  useEffect(() => {
    let newArr = []
    let deviceIdTopush = {}
    for (let idx1 = 0; idx1 < groupObj.length; idx1++) {
      const element = groupObj[idx1];
      if (element?.prepItems && element.prepItems.length > 0) {
        for (let idx = 0; idx < element.prepItems.length; idx++) {
          let ele = element.prepItems[idx];
          let warningColor = getWarningError(ele) && getWarningErrorColor(ele);
          if (element.id in deviceIdTopush) {
            ele['checkPrep'] = element;
            ele['warningColor'] = warningColor;
            deviceIdTopush[element.id].push(ele)
            newArr.pop()
            newArr.push({ ...deviceIdTopush })
          } else {
            ele['checkPrep'] = element;
            ele['warningColor'] = warningColor;
            deviceIdTopush[element.id] = [ele]
            newArr.push({ ...deviceIdTopush })
          }

        }
      }
    }

    const recallArr = newArr[newArr.length - 1]


    setRecallData(recallArr)
  }, [groupObj])


  const onSearchChange = (string) => {
    const key = string;
    setSearchString(string);
    const result = array.filter((item) => createFilter(key, headerArray, item));
    (result || [])?.forEach((check) => {
      if (nodes.indexOf(check.orderTypeId) === -1) {
        nodes.push(check.orderTypeId);
      }
      groupedOrderType[check.orderTypeId] = {
        groupName: check.orderTypeName,
        groupId: check.orderTypeId,
        list: [...(groupedOrderType[check.orderTypeId]?.list || []), check]
      };
    });
    setActiveNode(nodes);
    setSearchResults(groupedOrderType);
  };

  const getKeyboardStatus = (status) => {
    setKeyboardOpen(status)
  };
  const handleViewClick = (check) => {
    setSearchOverlay(false);
    setSearchString('');
    setViewSingle({ isOpen: true, data: { ...check } });
  };

  const handleActiveNode = (id) => {
    if (activeNode.indexOf(id) === -1) {
      setActiveNode(activeNode.concat(id));
    } else {
      setActiveNode(activeNode.filter((x) => x !== id));
    }
  }
  let arr = groupObj.map(obj => obj?.prepItems || [])
  const flatArr = arr.reduce((acc, curr) => {
    return acc.concat(curr);
  }, []);
  const count = flatArr.reduce((acc, curr) => {
    if (curr && curr.name !== null) {
      const name = curr.name;
      let curTime = new Date().getTime()
      let momentTime
      if (curr?.plannedPrepStartDate) {
        momentTime = convertUTCDateToLocalDate(new Date(curr?.plannedPrepStartDate)).getTime();
      }
      const getData = () => {
        acc[name] = { count: 1, notSchedule: 0, Schedule: 0, prepStatus: curr.prepStatus, plannedPrepStartDate: curr.plannedPrepStartDate, prepDeviceId: curr.prepDeviceId };

        if ((curr?.prepStatus === 2 || curr?.prepStatus === 5) && momentTime < curTime) {
          acc[name].notSchedule += 1;
        } else if ((curr?.prepStatus === 2 || curr?.prepStatus === 5) && momentTime >= curTime) {
          acc[name].Schedule += 1;
        }
      }

      if (typeof acc[name] === 'undefined') {
        if (deviceInfo?.kdsMirrorDeviceId == null || deviceInfo?.kdsMirrorDeviceId == undefined) {
          if ((duplicateDeviceIds[curr?.prepDeviceId]) && ((curr?.prepStatus >= 2 && curr?.prepStatus < 8))) {
            switch (currentState) {
              case 0: (curr.prepStatus == 2 || curr.prepStatus == 5) && ((curr.prepStatus == 2 || curr.prepStatus == 5) && momentTime && momentTime < curTime) && getData(); break;
              case 1: curr.prepStatus == 5 && getData(); break;
              case 2: curr.prepStatus == 2 && (curr.prepStatus == 2 && momentTime && momentTime < curTime) && getData(); break;
              case 3: !((curr.prepStatus == 5 || curr.prepStatus == 8) || (curr.prepStatus == 2 || curr.prepStatus == 5 || curr.prepStatus == 8) && momentTime && momentTime < curTime) && getData(); break;
            }
          }
        } else {
          if ((deviceInfo?.kdsMirrorDeviceId === curr?.prepDeviceId) && ((curr?.prepStatus >= 2 && curr?.prepStatus < 8))) {
            switch (currentState) {
              case 0: (curr.prepStatus == 2 || curr.prepStatus == 5) && ((curr.prepStatus == 2 || curr.prepStatus == 5) && momentTime && momentTime < curTime) && getData(); break;
              case 1: curr.prepStatus == 5 && getData(); break;
              case 2: curr.prepStatus == 2 && (curr.prepStatus == 2 && momentTime && momentTime < curTime) && getData(); break;
              case 3: !((curr.prepStatus == 5 || curr.prepStatus == 8) || (curr.prepStatus == 2 || curr.prepStatus == 5 || curr.prepStatus == 8) && momentTime && momentTime < curTime) && getData(); break;
            }
          }
        }
      } else {
        if (deviceInfo?.kdsMirrorDeviceId == null || deviceInfo?.kdsMirrorDeviceId == undefined) {
          if ((duplicateDeviceIds[curr?.prepDeviceId]) && (curr?.prepStatus === 2 && momentTime < curTime)) {
            if (currentState == 0 || currentState == 2) {
              acc[name].notSchedule += 1;
            }
          } else if ((duplicateDeviceIds[curr?.prepDeviceId]) && (curr?.prepStatus === 5)) {
            if (currentState == 1 || currentState == 0) {
              acc[name].notSchedule += 1;
            }
          } else {
            if (currentState == 3) {
              acc[name].Schedule += 1;
            }
          }

        } else {
          if ((deviceInfo?.kdsMirrorDeviceId === curr?.prepDeviceId) && (curr?.prepStatus === 2 && momentTime < curTime)) {
            if (currentState == 0 || currentState == 2) {
              acc[name].notSchedule += 1;
            }
          } else if ((deviceInfo?.kdsMirrorDeviceId === curr?.prepDeviceId) && (curr?.prepStatus === 5)) {
            if (currentState == 1 || currentState == 0) {
              acc[name].notSchedule += 1;
            }
          } else {
            if (currentState == 3) {
              acc[name].Schedule += 1;
            }
          }
        }
      }
      return acc;
    }
  }, {});
  const result = [];

  for (const key in count) {
    result.push({ name: key, count: count[key].count, notSchedule: count[key].notSchedule, Schedule: count[key].Schedule, prepStatus: count[key].prepStatus, plannedPrepStartDate: count[key].plannedPrepStartDate, prepDeviceId: count[key].prepDeviceId });
  }

  // function to clear filterData if all items on screen are bumped.
  (() => {
    if (Object.values(filterData)?.length > 0) {
      const tempArr = []
      for (let key in filterData) {
        if (filterData[key] === true) tempArr.push(key)
      }

      if (tempArr?.length > 0) {
        const arr = tempArr?.map(el => result?.some(val => val?.name === el))

        if (arr?.every((el) => el === false)) {
          setFilterData({})
        }
      }

    }
  })();

 
  const checkData = (groupObj) => {
    const deviceInfo = JSON.parse(window.sessionStorage.getItem('deviceInfo'))
    const currentTime = new Date().getTime()
    const expoObject = {}
    let newArr = []

    for (let idx1 = 0; idx1 < groupObj.length; idx1++) {
      const element = groupObj[idx1];
      let deviceIdTopush = {}
      let tempObj = {}
      const sortOrder = element?.sortOrder;
      const rePrioritized = element?.rePrioritized;
      const plannedStartDate = element?.plannedStartDate && moment.utc(element?.plannedStartDate).local();
      const plannedCompleteDate = element?.plannedCompleteDate && moment.utc(element?.plannedCompleteDate).local();
      if (element?.prepItems && element.prepItems.length > 0 && element?.prepItems.filter(value => duplicateDeviceIds[value.prepDeviceId] && value.prepStatus !== 8).length > 0) {
        for (let idx = 0; idx < element.prepItems.length; idx++) {
          const ele = element.prepItems[idx];
          const getData = () => {
            if (ele.prepDeviceId in deviceIdTopush) {
              ele['checkPrep'] = element;
              deviceIdTopush[ele.prepDeviceId].push(ele)
              newArr.pop()
              newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized });
            } else {

              ele['checkPrep'] = element;
              deviceIdTopush[ele.prepDeviceId] = [ele]
              newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized });
            }
          }
          if (deviceInfo?.kdsMirrorDeviceId == null || deviceInfo?.kdsMirrorDeviceId == undefined) {
            if (ele.prepDeviceId && duplicateDeviceIds[ele.prepDeviceId]) {
              let prepTime;
              if (ele.plannedPrepStartDate) {
                prepTime = convertUTCDateToLocalDate(new Date(ele.plannedPrepStartDate)).getTime()
              }

              if (((ele.prepStatus > 2 && ele.prepStatus <= 8) || (ele.prepStatus == 2 && prepTime && prepTime >= currentTime)) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                isItemInAllDay = true;
              }

              if (!toggle) {
                if (((ele.prepStatus >= 2 && ele.prepStatus <= 8)) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                  //  add 2 lines here
                  switch (currentState) {
                    case 0: (((ele.prepStatus == 2 || ele.prepStatus == 5 || ele.prepStatus == 8)) && prepTime && prepTime < currentTime) && getData(); break;
                    case 1: ele.prepStatus == 5 && getData(); break;
                    case 2: ele.prepStatus == 2 && (ele.prepStatus == 2 && prepTime && prepTime < currentTime) && getData(); break;
                    case 3: !((ele.prepStatus == 5 || ele.prepStatus == 8) || (ele.prepStatus == 2 || ele.prepStatus == 5 || ele.prepStatus == 8) && prepTime && prepTime < currentTime) && getData(); break;
                  }
                }
              }
              else {
                if ((ele.prepStatus >= 2 && ele.prepStatus <= 8) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                  //  add 2 lines here
                  if (ele.prepDeviceId in deviceIdTopush) {
                    ele['checkPrep'] = element;
                    deviceIdTopush[ele.prepDeviceId].push(ele);
                    newArr.pop();
                    newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized });

                  }
                  else {
                    ele['checkPrep'] = element;
                    if (Object.keys(deviceIdTopush).length < 1) {
                      deviceIdTopush[ele.prepDeviceId] = [ele];
                      newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized });
                    }
                    else {
                      if (ele.prepDeviceId in tempObj) {
                        tempObj[ele.prepDeviceId].push(ele)
                        newArr.pop();
                        newArr.push(tempObj);
                      }
                      else {
                        tempObj[ele.prepDeviceId] = [ele];
                        newArr.push(tempObj)
                      }
                    }
                  }
                }
              }
            }
          }
          else {
            if (ele.prepDeviceId && duplicateDeviceIds[ele.prepDeviceId]) {
              let prepTime;
              if (ele.plannedPrepStartDate) {
                prepTime = convertUTCDateToLocalDate(new Date(ele.plannedPrepStartDate)).getTime()
              }

              if (((ele.prepStatus > 2 && ele.prepStatus <= 8) || (ele.prepStatus == 2 && prepTime && prepTime >= currentTime)) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                isItemInAllDay = true;
              }
              if (!toggle) {
                if (((ele.prepStatus >= 2 && ele.prepStatus <= 8)) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                  //  add 2 lines here
                  switch (currentState) {
                    case 0: getData(); break;
                    case 1: ele.prepStatus == 5 && getData(); break;
                    case 2: ele.prepStatus == 2 && (ele.prepStatus == 2 && prepTime && prepTime < currentTime) && getData(); break;
                    case 3: !((ele.prepStatus == 5 || ele.prepStatus == 8) || (ele.prepStatus == 2 || ele.prepStatus == 5) && prepTime && prepTime < currentTime) && getData(); break;

                  }
                }
              } else {
                if ((ele.prepStatus >= 2 && ele.prepStatus <= 8) && (Object.keys(filterData)?.length === 0 || !Object.values(filterData)?.includes(true) || filterData?.[ele.name]) && ele.name !== null) {
                  //  add 2 lines here
                  if (ele.prepDeviceId in deviceIdTopush) {
                    ele['checkPrep'] = element;
                    deviceIdTopush[ele.prepDeviceId].push(ele)
                    newArr.pop()
                    newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized })
                  } else {
                    ele['checkPrep'] = element;
                    deviceIdTopush[ele.prepDeviceId] = [ele]
                    newArr.push({ ...deviceIdTopush, sortOrder: sortOrder, plannedStartDate, plannedCompleteDate, rePrioritized: rePrioritized })
                  }
                }
              }
            }
          }
        }
      }
      if (currentState == 0) {
        let arr = [];
        let tkey = null
        Object.keys(deviceIdTopush).forEach(key => {
          tkey = key;
          arr = deviceIdTopush[key].map((i) => { return !((i.prepStatus == 2 || i.prepStatus == 5) && convertUTCDateToLocalDate(new Date(i.plannedPrepStartDate)).getTime() < currentTime) });

        })
        if (arr.length > 0 && !arr.includes(false)) {
          newArr.pop()
        }
      }

    }

    const kdsSortLogic = (a, b) => {
      if (kdsSortType === 1) {
        return (a?.plannedStartDate < b?.plannedStartDate) ? -1 : (a?.plannedStartDate > b?.plannedStartDate) ? 1 : 0;
      }
      else if (kdsSortType === 2) {
        return (a?.plannedCompleteDate < b?.plannedCompleteDate) ? -1 : (a?.plannedCompleteDate > b?.plannedCompleteDate) ? 1 : 0;
      }
      else {
        return a?.sortOrder - b?.sortOrder;
      }
    }

    const prioritizedCheckArr = newArr?.filter(el => el.rePrioritized)?.sort((a, b) => kdsSortLogic(a, b));
    const nonPriorityCheckArr = newArr?.filter(el => !el.rePrioritized)?.sort((a, b) => kdsSortLogic(a, b))

    newArr = [...prioritizedCheckArr, ...nonPriorityCheckArr];

    newArr.map(el => {
      delete el.sortOrder;
      delete el.plannedStartDate;
      delete el.plannedCompleteDate;
      delete el.rePrioritized;
    })

    let dataVal = [];
    for (let index = 0; index < newArr.length; index++) {
      let element = newArr[index];
      if (element) {
        const key = Object.keys(element)[0];
      }
      let page;
      if (columnCount && rowCount) {
        page = Math.floor(index / (columnCount * rowCount));
      } else {
        page = Math.floor(index / 8);
      }
      (expoObject[page] = expoObject[page] || []).push({ ...element });
      (dataVal[page] = dataVal[page] || []).push({ ...element });
    }
    if (dataVal.length > 0 && dataVal.length - 1 - currentPage === -1) {
      setCurrentPage(currentPage - 1)
    }
    expoObject[0] ? isItemInAllDay = true : isItemInAllDay = false
    return expoObject[0] ? expoObject : []
  }

  useLayoutEffect(() => {
    if (viewSingle?.isOpen) {
      const array = Object.values(groupObj || {}).flat();
      const result = array.find((d) => d.id === viewSingle?.data?.id);
      setViewSingle({
        ...viewSingle,
        data: result
      });
    }
    if (searchOverlay) {
      const result = array.filter((item) => createFilter(searchString, headerArray, item));
      (result || [])?.forEach((check) => {
        groupedOrderType[check.orderTypeId] = {
          groupName: check.orderTypeName,
          groupId: check.orderTypeId,
          list: [...(groupedOrderType[check.orderTypeId]?.list || []), check]
        };
      });
      setSearchResults(groupedOrderType);
    }
    setPageNewBuildArr(groupObj)
  }, [groupObj]);

  const getDisplayStyle = () => {
    let height = 50;
    let width = 25;
    if (columnCount && rowCount) {
      width = 100 / columnCount
      height = 100 / rowCount
    }
    return { height: `${height}%`, width: `${width}%` };
  };

  const getTowRowTileHeight = (item) => {
    if (item && item?.length > 0) {
      if (item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.doNotMake && item[0]?.checkPrep?.offPremise) {
        if (window?.innerHeight <= 530) { return "18%"; }
        else { return "28%"; }
      }
      if ((item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.offPremise) || (item[0]?.checkPrep?.doNotMake && item[0]?.checkPrep?.offPremise) ||
        (item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.doNotMake && (!item[0]?.checkPrep?.offPremise && item[0]?.checkPrep?.courseName))
      ) {
        if (window?.innerHeight <= 530) { return "26%"; }
        else { return "35%"; }
      }
      if (item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.doNotMake) {
        if (window?.innerHeight <= 530) { return "34%"; }
        else { return "42%"; }
      }
      if ((item[0]?.checkPrep?.hasAllergy || item[0]?.checkPrep?.doNotMake || item[0]?.checkPrep?.courseName)) {
        if (window?.innerHeight <= 530) { return "43%"; }
        else { return "50%" }
      }
    }
  }

  const getTileHeight = (item) => {
    if (rowCount && columnCount) {
      if (rowCount === 4) {
        return '35%'
      } else if (rowCount === 3) {
        return '40%'
      } else if (rowCount === 2) {

        const tileHeight = getTowRowTileHeight(item);
        if (tileHeight) return tileHeight;

        if (window?.innerHeight <= 530) { return '52%'; }
        else { return '60%'; }

      } else if (rowCount === 1) {
        if (item && item?.length > 0 && (item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.doNotMake && item[0]?.checkPrep?.courseName)) {
          if (window?.innerHeight <= 530) { return '63%'; }
          else { return '68%'; }
        }
        if (item && item?.length > 0 && (item[0]?.checkPrep?.hasAllergy && item[0]?.checkPrep?.doNotMake)) {
          if (window?.innerHeight <= 530) { return '68%'; }
          else { return '72%'; }
        }
        if (item && item?.length > 0 && (item[0]?.checkPrep?.hasAllergy || item[0]?.checkPrep?.doNotMake || item[0]?.checkPrep?.courseName)) {
          if (window?.innerHeight <= 530) { return '72%'; }
          else { return '76%'; }
        }

        if (window?.innerHeight <= 530) { return '77%'; }
        else { return "80%"; }

      }
    }

    const tileHeight = getTowRowTileHeight(item);
    if (tileHeight) return tileHeight;

    if (window?.innerHeight <= 530) { return '52%' }
    else { return "58%" }
  }

  const handleTicketExpandView = (data, headerColor) => {
    data?.forEach((item) => {
      item['warningColor'] = headerColor;
    })
    setShowTicketExpandModal(!showTicketExpandModal)
    setTicketExpandData(data)
  }

  const getTime = (date) => {
    if (date === null) {
      return true;
    }
    const momentTime = moment.utc(date).local();
    const currentTime = moment();
    return currentTime > momentTime ? true : false
  }

  useEffect(() => {
    const pageData = !viewSingle?.isOpen && pageBuildArr?.length > 0 && checkData(pageBuildArr)[currentPage]?.length > 0 && checkData(pageBuildArr) || [];
    let newOrder = 0, processCount = 0, inProgress = 0, yellowCount = 0, orangeCount = 0, redCount = 0;
    Object.values(pageData)?.forEach(data => {
      data?.forEach(check => {
        let id = 1;
        Object.values(check)[0].forEach((item) => {
          const warningColorId = !getTime(item.prepStartDate ? item.prepStartDate : item.plannedPrepStartDate) ? 0 : item.prepStatus == 0 && item.buildStatus == 0 ? isModifier ? 0 : 1 : getWarningError(item) ? getWarningErrorColor(item) : 1;
          const colorId = warningColorId === '' ? 1 : warningColorId === 'yellow' ? 2 : warningColorId === '#F49F40' ? 3 : warningColorId === '#FF6464' ? 4 : warningColorId;
          if (item?.buildStatus == 2) {
            processCount += 1;
          } if (item?.buildStatus == 5) {
            inProgress += 1;
          }
          if (item.checkPrep.receivedDate > lastActiveTime) {
            newOrder += 1
          }
          if (colorId > id) id = colorId;
        });
        switch (id) {
          case 2: yellowCount += 1;
            break;
          case 3: orangeCount += 1;
            break;
          case 4: redCount += 1;
            break;
        }
      });
    });
    setHeaderCount({ newOrder, processCount, inProgress, yellowCount, orangeCount, redCount })
  }, [pageBuildArr, counter]);

  return (
    <>
      <Navbar
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        PrepFooter={PrepFooter}
        footerSelection={footerSelection}
        filterData={filterData}
        setCurrentPage={setCurrentPage}
        newOrder={headerCount.newOrder}
        processCount={headerCount.processCount}
        inProgress={headerCount.inProgress}
        yellowCount={headerCount.yellowCount}
        orangeCount={headerCount.orangeCount}
        redCount={headerCount.redCount}
        station='prep'
        setToggle={setToggle}
        toggle={false}
        states={states}
        currentState={currentState}
        toggleState={toggleState}
      />
      {
        showMenu && (
          <HamburgerSideBarMenu
            setShowMenu={setShowMenu}
            handleLogout={handleLogout}
            duplicateData={duplicateData}
            History={History}
            activeScreenType={activeScreenType}
            handleShowRecallModal={handleShowRecallModal}
          />
        )
      }
      <div className={cn('p-0 h-80 align-content-start row overflowX overflowYHidden mx-0 w-100 col-12 p-1', styles.grid)}>
        {!viewSingle?.isOpen && pageBuildArr?.length > 0 && checkData(pageBuildArr)[currentPage]?.length > 0 ? checkData(pageBuildArr)[currentPage]?.map((check, index) => {
          return (
            <div role="presentation" key={check[0]?.name} className={cn(`px-0`, !(rowCount && columnCount) && 'col-3')} style={{ marginBottom: '0.2%', paddingBottom: '0.2%', paddingLeft: '0 !important', paddingRight: '0 !important', height: getDisplayStyle().height, width: rowCount && columnCount ? getDisplayStyle().width : 'none' }} >
              <StationCard
                check={Object.values(check)[0]}
                checkindex={index}
                searchOverlay={searchOverlay}
                bumpApiCall={bumpApiCall}
                prepStartAll={prepStartAll}
                convertUTCDateToLocalDate={convertUTCDateToLocalDate}
                themeProperties={themeProperties}
                bumpApiSelected={bumpApiSelected}
                getTileHeight={getTileHeight}
                getPrepCompletedTime={getPrepCompletedTime}
                duplicateDeviceIds={duplicateDeviceIds}
                handleTicketExpandView={handleTicketExpandView}
                getWarningError={getWarningError}
                getWarningErrorColor={getWarningErrorColor}
                currentPage={currentPage}
                getTime={getTime}
                loading={loading}
                lastActiveTime={lastActiveTime}
                receipePdfApiCall={receipePdfApiCall}
                pdfUrl={pdfUrl}
                setPdfUrl={setPdfUrl}
                setRecipeModalData={setRecipeModalData}
                checkPrepsListHashTable={checkPrepsListHashTable}
                filterData={filterData}
                currentState={currentState}
                getPickupTime={getPickupTime}
              />

            </div>
          );
        }) : !isItemInAllDay && (<> <div className='text-center w-50' style={{ height: '15vw', position: 'fixed', top: '20vw', left: '25%' }}>
          <div className='font-weight-bold' style={{ position: 'absolute', top: '6vw', left: '20%', color: 'black' }}>NO TICKETS AVAILABLE RIGHT NOW
          </div>
        </div></>)}
        {
          showTicketExpandModal && <div className={styles.overlay}>
            <TicketExpandModal
              ticketExpandData={ticketExpandData}
              handleTicketExpandView={handleTicketExpandView}
              searchOverlay={searchOverlay}
              bumpApiCall={bumpApiCall}
              prepStartAll={prepStartAll}
              convertUTCDateToLocalDate={convertUTCDateToLocalDate}
              themeProperties={themeProperties}
              bumpApiSelected={bumpApiSelected}
              getTileHeight={getTileHeight}
              getPrepCompletedTime={getPrepCompletedTime}
              duplicateDeviceIds={duplicateDeviceIds}
              kdsSettings={deviceInfo?.deviceGroup?.kdsSettings}
              pdfUrl={pdfUrl}
              setPdfUrl={setPdfUrl}
              receipePdfApiCall={receipePdfApiCall}
              setRecipeModalData={setRecipeModalData}
              setShowTicketExpandModal={setShowTicketExpandModal}
            />
          </div>
        }

        {searchOverlay && (
          <div className='position-absolute w-100 h-100'>
            <div className='h-10 w-100'><SearchComponent onChange={(e) => onSearchChange(e)} autoKeyboard getKeyboardStatus={getKeyboardStatus} /></div>
            <div className={cn('overflowY w-100 p-1 rounded', KeyboardOpen ? 'h-50' : 'h-90')}>
              {(Object.keys(searchResults)?.length > 0) && Object.values(searchResults || {})?.map(({ groupName, groupId, list }) => {
                return (
                  <div className='d-flex flex-wrap fs-20 fw-600 text-capitalize'>
                    <div className='w-90 text-left'>{`${groupName} (${list.length})`}</div>
                    <div
                      role="presentation"
                      onClick={() => handleActiveNode(groupId)}
                      className='w-10 text-right'
                    >
                      {activeNode.includes(groupId) ? <i className="fa fa-chevron-up" aria-hidden="true" /> : <i className="fa fa-chevron-down" aria-hidden="true" />}
                    </div>
                    {activeNode.includes(groupId) && list?.length > 0 && list?.map((check) => {
                      return (
                        <div className={cn('col-4 p-2 color-black fs-18 fw-600')}>
                          <div className='rounded bg-dark row mx-0 align-content-start p-2'>
                            <div className='w-80 p-0 text-truncate'>{check.name || check.stationName || check.stationNumber}</div>
                            <div
                              role="presentation"
                              onClick={() => handleViewClick(check)}
                              className='w-20 d-flex justify-content-center color-white align-items-center text-center p-0 bg-lightblue rounded align-self-stretch fs-18'
                            >
                              {LABEL().VIEW}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {viewSingle?.isOpen && (
          <div className='p-1 w-100 h-100'>
            {[viewSingle?.data]?.map((check) => {
              return (
                <div className='h-100 w-100 '>
                  <StationCard
                    check={check}
                    searchOverlay={searchOverlay}
                    convertUTCDateToLocalDate={convertUTCDateToLocalDate}
                    getTime={getTime}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer
        checkData={checkData}
        groupObj={groupObj}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        station='build'
        result={result}
        filterData={filterData}
        footerSelection={footerSelection}
        setToggle={setToggle}
        toggle={toggle}
      />
    </>
  );
};

const mapStateToProps = ({ storeChecks }) => ({
  loading: storeChecks.bumpLoading
})

export default connect(mapStateToProps, null)(KdsPrepStation)
